import { TranslationGroupEntry, TranslationGroupType } from "@medapro-types/TranslationManager/translationManager";

export function getTranslationGroupEntryMaxLength(groupType: TranslationGroupType) {
  switch (groupType) {
    case TranslationGroupType.CatalogGroupNames:
    case TranslationGroupType.AttributeUnits:
    case TranslationGroupType.VariationGroups:
    case TranslationGroupType.GlobalAttributeUnits:
      return 256;
    case TranslationGroupType.ArticleNames:
      return 80;
    case TranslationGroupType.AttributeValues:
    case TranslationGroupType.CatalogGroupAttributes:
    case TranslationGroupType.Keywords:
      return 1024;
    case TranslationGroupType.ArticleDescriptions:
    case TranslationGroupType.CatalogGroupDescriptions:
      return 32000;
    case TranslationGroupType.GlobalAttributeValues:
      return 4000;
  }
}

export function isUsingCatalogPath(groupType: TranslationGroupType) {
  switch (groupType) {
    case TranslationGroupType.CatalogGroupNames:
    case TranslationGroupType.VariationGroups:
    case TranslationGroupType.CatalogGroupAttributes:
    case TranslationGroupType.CatalogGroupDescriptions:
      return true;
    case TranslationGroupType.AttributeUnits:
    case TranslationGroupType.GlobalAttributeUnits:
    case TranslationGroupType.ArticleNames:
    case TranslationGroupType.AttributeValues:
    case TranslationGroupType.Keywords:
    case TranslationGroupType.ArticleDescriptions:
    case TranslationGroupType.GlobalAttributeValues:
      return false;
  }
}

export function getUnchangedTranslationGroupEntry(entry: TranslationGroupEntry): TranslationGroupEntry {
  if (entry.originalTargetText !== entry.targetText) {
    return {
      count: entry.count,
      sourceText: entry.sourceText,
      targetText: entry.originalTargetText,
      originalTargetText: entry.originalTargetText,
      detailEntries: entry.detailEntries,
      hasDifferingValues: entry.hasDifferingValues
    };
  }

  return entry;
}
